import { render } from "./HomeFollowing.vue?vue&type=template&id=08882d56&scoped=true"
import script from "./HomeFollowing.vue?vue&type=script&lang=js"
export * from "./HomeFollowing.vue?vue&type=script&lang=js"

import "./HomeFollowing.vue?vue&type=style&index=0&id=08882d56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08882d56"]])

export default __exports__